<script>

import OccupationsFilter from "@/views/Occupation/Components/OccupationsFilter.vue";
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import useTools from "@/use/Tools";
import {onMounted, ref, watch} from "vue";
import axios from "axios";

export default {
    name: 'StrOccupationDataTableSelect',
    props: {
        id: Number,
    },
    components: {SimpleOccupationsFilter: OccupationsFilter},
    setup(props, {emit}) {
        const {
            loading,
            dialog,
            page,
            pageCount,
            itemsPerPage,
            paginationListLength,
            total,
            inputColor,
            backgroundColor,
            chipElevation,
            tableElevation
        } = useSharedData();
        const {rowColor, itemClick, transformFilterValues} = useSharedMethod();
        const {$i18n} = useTools();
        const occupations = ref([]);
        const selectedOccupation = ref([]);
        
        const headers = ref([
            {
                text: $i18n.t("common.code"),
                align: "start",
                sortable: true,
                value: "code",
                width: '0%'
            },
            {
                text: $i18n.t("common.name"),
                align: "start",
                sortable: true,
                value: "name",
                width: '0%'
            },
            {
                text: $i18n.t("occupation.category"),
                align: "center",
                sortable: true,
                value: "categoryName",
            },
        ]);
        const filter = ref({
            paySectionId: [],
        });
        
        function findAll() {
            loading.value = true;
            filter.value.paySectionIds = filter.value.paySectionId.toString();
            axios.get('/occupations', {params: transformFilterValues(filter.value)}).then((response) => {
                total.value = response.data.length;
                occupations.value = response.data;
                let o = occupations.value.find(e => e.id === props.id);
                if (o) {
                    selectedOccupation.value.push(o);
                }
            }).finally(() => {
                loading.value = false;
            });
        }
        
        watch(() => selectedOccupation.value, () => {
            emit('updateSelectedOccupation', selectedOccupation.value);
        }, {deep: true, immediate: true})
        
        onMounted(() => findAll());
        
        watch(
            filter,
            () => {
                page.value = 1;
                findAll();
                emit('updateFilter', filter.value);
            },
            {deep: true}
        );
        
        return {
            loading,
            dialog,
            page,
            pageCount,
            itemsPerPage,
            paginationListLength,
            total,
            inputColor,
            backgroundColor,
            chipElevation,
            tableElevation,
            headers,
            filter,
            occupations,
            selectedOccupation,
            itemClick,
            rowColor,
            findAll,
        }
    },
}
</script>

<template>
    <div>
        <v-card-text>
            <SimpleOccupationsFilter :filter="filter"></SimpleOccupationsFilter>
        </v-card-text>
        <w-data-table
            v-model="selectedOccupation"
            :headers="headers"
            :items="occupations"
            :loading="loading"
            sort-by="name"
            show-select
            disable-pagination
            fixed-header
            height="500"
        >
            <template v-slot:[`item.code`]="{ item }">
                <w-chip :text="item.code"/>
            </template>
            <template v-slot:[`item.name`]="{ item }">
                <w-inline-text bold :text="item.name"/>
            </template>
            <template v-slot:[`item.categoryName`]="{ item }">
                <w-inline-text :text="item.categoryFullName"/>
            </template>
        </w-data-table>
    </div>
</template>

<style scoped>

</style>